// Packages
import React from "react"
import { graphql } from "gatsby"

// Components
import ArticleContent from "@components/knowledge-center/article-content"
import AlgoliaResults from "@components/knowledge-center/algolia-results"
import SEO from "@components/global/seo"

const Article = props => {
  const {
    searchBoxFocus,
    setSearchBoxFocus,
    teamApplyToggle,
    setTeamApplyToggle,
  } = props
  const articleData = props.data?.contentfulBlogPost

  return (
    <>
      {searchBoxFocus ? (
        <AlgoliaResults
          setSearchBoxFocus={setSearchBoxFocus}
          bankerData={props.bankerData}
        />
      ) : (
        <ArticleContent
          articleData={articleData}
          bankerData={props.bankerData}
          teamApplyToggle={teamApplyToggle}
          setTeamApplyToggle={setTeamApplyToggle}
          walledVersion={props.version}
        />
      )}
    </>
  )
}

// Meta tags
export const Head = props => {
  const articleData = props.data?.contentfulBlogPost
  const canonicalSlug = props.pageContext.canonicalSlug
  return (
    <SEO
      description={`${articleData.excerpt.childMarkdownRemark.rawMarkdownBody}`}
      ogImage={articleData.ogImage && articleData.ogImage.url}
      title={articleData.title}
      canonicalSlug={canonicalSlug}
      slug={props.location.pathname.replace(/^\//, "").replace(/\/$/, "")}
      hidden={articleData.hidden}
    />
  )
}
export default Article

export const query = graphql`
  query ArticleQuery($articleSlug: String!) {
    contentfulBlogPost(slug: { eq: $articleSlug }) {
      title
      slug
      category
      author
      hidden
      date(formatString: "MMM YYYY")
      updatedAt(formatString: "MM/DD/YYYY")
      whatYouLearn {
        textBody
      }
      disclosure {
        childMarkdownRemark {
          html
        }
      }
      ogImage {
        gatsbyImageData(width: 1200, height: 628, quality: 90)
        url
      }
      excerpt {
        childMarkdownRemark {
          rawMarkdownBody
        }
      }

      body {
        childMarkdownRemark {
          html
          timeToRead
        }
      }
      content {
        raw
        references {
          ... on ContentfulArticleAd {
            contentful_id
            __typename
            type
          }
          ... on ContentfulArticleCallout {
            contentful_id
            __typename
            callout {
              raw
              references {
                ... on ContentfulArticleInternalLink {
                  contentful_id
                  __typename
                  category
                  link
                  linkText
                }
              }
            }
          }
          ... on ContentfulArticleDefinition {
            contentful_id
            __typename
            definition {
              raw
            }
            type
            title
          }
          ... on ContentfulArticleImage {
            contentful_id
            __typename
            image {
              gatsbyImageData
              file {
                url
              }
              title
            }
            caption {
              raw
            }
          }
          ... on ContentfulArticleInternalLink {
            contentful_id
            __typename
            category
            link
            linkText
          }
          ... on ContentfulArticleTip {
            contentful_id
            __typename
            tip {
              raw
              references {
                ... on ContentfulArticleInternalLink {
                  contentful_id
                  __typename
                  category
                  link
                  linkText
                }
                ... on ContentfulArticleTooltip {
                  contentful_id
                  __typename
                  tooltip {
                    childMarkdownRemark {
                      html
                      rawMarkdownBody
                    }
                  }
                  word
                }
              }
            }
          }
          ... on ContentfulArticleTooltip {
            contentful_id
            __typename
            tooltip {
              childMarkdownRemark {
                html
                rawMarkdownBody
              }
            }
            word
          }
          ... on ContentfulArticleQuote {
            contentful_id
            __typename
            quote {
              raw
            }
            context
            attribution
          }
          ... on ContentfulAsset {
            contentful_id
            __typename
            title
            file {
              url
            }
          }
        }
      }
      featuredImage {
        gatsbyImageData(width: 1200, quality: 90)
      }
      featureImage {
        gatsbyImageData(width: 1200, quality: 90)
      }
    }
  }
`
